var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_pdf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Documents",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-30.000000, -30.000000)",
    fill: "#D11F1A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,30 C47.1045695,30 48,30.8954305 48,32 L48,46 C48,47.1045695 47.1045695,48 46,48 L32,48 C30.89,48 30,47.1 30,46 L30,32 C30,30.89 30.89,30 32,30 L46,30 L46,30 Z M37.59,37.08 C37.57,37.13 37.3,38.84 35.5,41.77 C35.5,41.77 32,43.58 32.83,44.94 C33.5,46 35.15,44.9 36.56,42.27 C36.56,42.27 38.38,41.63 40.79,41.45 C40.79,41.45 44.65,43.19 45.17,41.34 C45.69,39.5 42.12,39.9 41.5,40.09 C41.5,40.09 39.46,38.75 39,36.89 C39,36.89 40.13,32.95 38.38,33 C36.63,33.05 37.29,36.12 37.59,37.08 L37.59,37.08 Z M38.4,38.13 C38.43,38.13 38.87,39.33 40.29,40.58 C40.29,40.58 37.96,41.04 36.9,41.5 C36.9,41.5 37.9,39.75 38.4,38.13 L38.4,38.13 Z M42.32,40.84 C42.9,40.69 44.64,41 44.58,41.32 C44.5,41.65 42.32,40.84 42.32,40.84 L42.32,40.84 Z M35.26,42.7 C34.73,43.91 33.83,44.68 33.6,44.67 C33.37,44.66 34.3,43.07 35.26,42.7 L35.26,42.7 Z M38.4,35.76 C38.39,35.71 38.03,33.57 38.4,33.61 C38.94,33.67 38.4,35.71 38.4,35.76 Z",
    id: "icon_pdf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.3e50082a1b9e19b0366632d1f1960f7e.svg";
export { ForwardRef as ReactComponent };